import {coefficientLatex,quadraticPolynomialLatex,shiftedXLatex} from "../../utils/polynomialLatex";
const step=(title,math)=>({title,math});
const frac=(n,d)=>{
 const sign=n*d<0?"-":"";let a=Math.abs(n),b=Math.abs(d),x=a,y=b;
 while(y)[x,y]=[y,x%y];a/=x;b/=x;
 return b===1?`${sign}${a}`:String.raw`${sign}\frac{${a}}{${b}}`;
};
export function getQuadraticInequalitySolutionSteps(task){
 const v=task.data?.values;if(!v)return null;
 switch(task.type){
  case "MaturaBasic_quadratic-inequality-negative-between-fractional-roots": {
   const [a,t]=v,b=-(a-1)*t,c=-t*t,delta=(a+1)**2*t*t,lo=frac(-t,a);return [
    step("Rozwijamy nawias i przenosimy wszystkie wyrazy na lewą stronę.",String.raw`x(${quadraticPolynomialLatex(0,a,-(a-1)*t)})<${t*t}\iff ${quadraticPolynomialLatex(a,b,c)}<0`),
    step("Liczymy wyróżnik trójmianu i jego pierwiastek.",String.raw`\Delta=(${b})^2-4\cdot${a}\cdot(${c})=${delta},\qquad\sqrt\Delta=${(a+1)*t}`),
    step("Wyznaczamy miejsca zerowe i porządkujemy je rosnąco.",String.raw`x_1=\frac{${-b}-${(a+1)*t}}{${2*a}}=${lo},\qquad x_2=\frac{${-b}+${(a+1)*t}}{${2*a}}=${t}`),
    step("Ramiona paraboli są skierowane w górę. Ujemne wartości są pomiędzy miejscami zerowymi; ostra nierówność wyklucza końce.",String.raw`x\in(${lo};${t})`),
   ];
  }
  case "MaturaBasic_ProductShiftedStrictQuadraticInequality": {
   const [h,r]=v,lo=h-r,hi=h+r,shift=shiftedXLatex(h);return [
    step("Rozpoznajemy iloczyn różnicy i sumy. Korzystamy z różnicy kwadratów.",String.raw`((${shift})-4)((${shift})+4)=(${shift})^2-16`),
    step("Dodajemy 16 do obu stron i zapisujemy trójmian po jednej stronie.",String.raw`(${shift})^2>${r*r}\iff (${shift})^2-${r*r}>0`),
    step("Wyznaczamy miejsca zerowe trójmianu.",String.raw`(${shift})^2=${r*r}\iff x=${h}-${r}=${lo}\ \text{lub}\ x=${h}+${r}=${hi}`),
    step("Dodatni współczynnik przy x² oznacza dodatnie wartości poza miejscami zerowymi. Ostry znak wyklucza oba końce.",String.raw`x\in(-\infty;${lo})\cup(${hi};+\infty)`),
   ];
  }
  case "MaturaBasic_ExpandedProductQuadraticClosedInterval": {
   const [h,r]=v,lo=h-r,hi=h+r;return [
    step("Rozwijamy iloczyn i przenosimy prawą stronę na lewą.",String.raw`x(x-${2*h})\le${r*r-h*h}\iff ${quadraticPolynomialLatex(1,-2*h,h*h-r*r)}\le0`),
    step("Liczymy wyróżnik i miejsca zerowe trójmianu.",String.raw`\Delta=(${ -2*h})^2-4\cdot(${h*h-r*r})=${4*r*r},\qquad x_1=\frac{${2*h}-${2*r}}2=${lo},\quad x_2=\frac{${2*h}+${2*r}}2=${hi}`),
    step("Ramiona paraboli są skierowane w górę. Wartości niedodatnie leżą pomiędzy miejscami zerowymi, razem z nimi.",String.raw`x\in[${lo};${hi}]`),
    {optional:true,title:"Szybsza metoda: dopełnienie kwadratu",math:String.raw`x^2-${2*h}x+${h*h}\le${r*r}\iff(x-${h})^2\le${r*r}\iff -${r}\le x-${h}\le${r}`},
   ];
  }
  case "MaturaBasic_QuadraticInequalityProductVersusLinear": {
   const [a,b,c]=v,hi=frac(b+c,a);return [
    step("Rozwijamy nawias i przenosimy wyraz z prawej strony na lewą.",String.raw`x(${a}x-${b})<${c}x\iff ${a}x^2-${b+c}x<0`),
    step("Wyłączamy x przed nawias. Nie dzielimy nierówności przez x, ponieważ nie znamy jego znaku.",String.raw`x(${a}x-${b+c})<0`),
    step("Przyrównujemy każdy czynnik do zera i wyznaczamy oba miejsca zerowe.",String.raw`x_1=0,\qquad ${a}x-${b+c}=0\iff x_2=${hi}`),
    step("Współczynnik przy x² jest dodatni, więc iloczyn jest ujemny pomiędzy miejscami zerowymi. Ostry znak wyklucza końce.",String.raw`x\in(0;${hi})`),
   ];
  }
  case "MaturaBasic_FactoredQuadraticStrictClosed": {
   const [a,l,r]=v;return [
    step("Dzielimy przez ujemny współczynnik stojący przed iloczynem i odwracamy znak nierówności.",String.raw`${coefficientLatex(-a)}(x+${l})(x-${r})>0\iff(x+${l})(x-${r})<0`),
    step("Wyznaczamy miejsca zerowe obu czynników.",String.raw`x+${l}=0\iff x_1=-${l},\qquad x-${r}=0\iff x_2=${r}`),
    step("Pomiędzy miejscami zerowymi pierwszy czynnik jest dodatni, a drugi ujemny, więc ich iloczyn jest ujemny.",String.raw`-${l}<x<${r}`),
    step("Wybieramy przedział otwarty. W miejscach zerowych pierwotny iloczyn jest równy zero, więc nie spełnia ostrej nierówności.",String.raw`x\in(-${l};${r})`),
   ];
  }
  case "MaturaBasic_FactoredQuadraticInequalityUnknownRootParameter": {
   const [a,r,l]=v;return [
    step("Zerujemy oba czynniki, aby powiązać miejsca zerowe z końcami podanego przedziału.",String.raw`${a}x-${a*r}=0\iff x=${r},\qquad x+k=0\iff x=-k`),
    step("Współczynnik przy x² jest dodatni, a iloczyn ma być ujemny. Rozwiązanie leży pomiędzy dwoma miejscami zerowymi.",String.raw`x\in(-${l};${r})`),
    step("Znamy już dodatnie miejsce zerowe. Drugie, ujemne, jest równe lewemu końcowi przedziału.",String.raw`-k=-${l}\iff k=${l}`),
   ];
  }
  default:return null;
 }
}
